<template>
    <div class="history-slider">
        <div class="inSalabamMonographicSlider">
            <Spinner v-if="loading" />
            <div v-else class="postSlider">
                <div class="postSlider" v-if="!loading">
                    <div class="sliderHeading">
                        <div class="sliderHeading--icon">
                            <font-awesome-icon icon="eye"/>
                        </div>
                        <div class="sliderHeading--title">
                            <strong>Visti di recente</strong>
                            <br>
                            <span class="d-flex align-items-center flex-wrap">
                                <span v-if="history.length == 0" class="history-slider__message">
                                    La tua cronologia di navigazione è vuota
                                </span>
                                <span v-else>In un click, le disponibilità delle strutture che hai gia esaminato</span>
                            </span>
                        </div>
                    </div>
                    <!-- versione mobile: pad informativa inserita tra le slides -->
                    <div v-if="history.length > 0" class="slick mobile">
                        <Slick :ref="_uid+'_slick'" :options="slickOptionsMobile" @init="handleInit">

                        <div class="property_pad" v-for="(visited, index) in (history.length > 3 ? (history.slice(0,2)): history)" :key="'slide-m-'+index" :data-property_id="visited.property.propertyId">
                            <div class="postPad" @click="goToProperty(visited)">
                                <div class="postPad__thumbnail" :style="'background-image:url('+visited.property.image+');'"></div>
                                    <div class="postPad__content">
                                        <div>
                                        <div class="postPad__title d-flex">
                                            <SvgOccupancy />
                                            <span>{{visited.property.name}}</span>
                                        </div>
                                        <div class="property-pad__city">
                                            <SvgPin />
                                            {{visited.property.address}}, {{visited.property.city}}
                                        </div>
                                        <div class="property__amenities">
                                            <span v-for="(value,index) in (Object.keys(visited.property.amenities))" v-bind:key="value">
                                                <span :class="'amenity '+(icons['propertyAmenities'][value] !== undefined ? icons['propertyAmenities'][value] : 'icon-default')" v-if="amenitiesLabels[value] && index < 2">
                                                    {{amenitiesLabels[value].label}}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="infoPad">
                            <div class="background">
                                <h5 class="title">
                                    <font-awesome-icon icon="eye"/>
                                    Visti di recente
                                </h5>
                                <p class="abstract">
                                    Scopri con un click disponibilità e prezzi di tutte le strutture che hai già esaminato
                                </p>
                                <span class="btn link" @click="searchLite()">Scopri le disponibilità</span>
                            </div>
                        </div>

                        <div class="property_pad" v-for="(visited,index) in (history.length > 3 ? (history.slice(2,history.length)) : history)" :key="'slide-m-'+(index+3)" :data-property_id="visited.property.propertyId">
                            <div class="postPad" @click="goToProperty(visited)">
                                <div class="postPad__thumbnail" :style="'background-image:url('+visited.property.image+');'"></div>
                                    <div class="postPad__content">
                                        <div class="propertyRate">
                                        <div class="postPad__title d-flex">
                                            <SvgOccupancy />
                                            <span>{{visited.property.name}}</span>
                                        </div>
                                        <div class="property-pad__city">
                                            <SvgPin />
                                            {{visited.property.address}}, {{visited.property.city}}
                                        </div>
                                        <div class="property__amenities">
                                            <span v-for="(value,index) in (Object.keys(visited.property.amenities))" v-bind:key="value">
                                                <span :class="'amenity '+(icons['propertyAmenities'][value] !== undefined ? icons['propertyAmenities'][value] : 'icon-default')" v-if="amenitiesLabels[value] && index < 2">
                                                    {{amenitiesLabels[value].label}}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        </Slick>

                        <span class="slick-arrow slick-prev" :id="'slick-prev-inSalabam'+_uid+'_m'">
                            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.6" d="M30 59.9992C46.5685 59.9992 60 46.5681 60 29.9996C60 13.4311 46.5685 0 30 0C13.4315 0 0 13.4311 0 29.9996C0 46.5681 13.4315 59.9992 30 59.9992Z" fill="white"/>
                            <path d="M33.5758 43.5237L20.2078 30.0001L33.5758 16.4766" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>

                        <span class="slick-arrow slick-next" :id="'slick-next-inSalabam'+_uid+'_m'">
                            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.6" d="M30 59.9992C46.5685 59.9992 60 46.5681 60 29.9996C60 13.4311 46.5685 0 30 0C13.4315 0 0 13.4311 0 29.9996C0 46.5681 13.4315 59.9992 30 59.9992Z" fill="white"/>
                            <path d="M33.5758 43.5237L20.2078 30.0001L33.5758 16.4766" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </div>
                    <!-- versione desktop: pad informativa fissa a destra -->
                    <div v-if="history.length > 0" class="slick desktop">
                        <div class="slick-wrapper">

                            <Slick :ref="_uid+'_slick'" :options="slickOptionsDesktop" @init="handleInit">

                            <div class="property_pad" v-for="(visited, index) in history" :key="'slide-'+(index+2)" :data-property_id="visited.property.propertyId">
                                <div class="postPad" @click="goToProperty(visited)">
                                <div class="postPad__thumbnail" :style="'background-image:url('+visited.property.image+');'"></div>
                                    <div class="postPad__content">
                                        <div class="propertyRate">
                                            <div class="postPad__title d-flex">
                                                <SvgOccupancy />
                                                <span>{{visited.property.name}}</span>
                                            </div>
                                            <div class="property-pad__city">
                                                <SvgPin />
                                                {{visited.property.address}}, {{visited.property.city}}
                                            </div>
                                            <div class="property__amenities">
                                                <span v-for="(value,index) in (Object.keys(visited.property.amenities))" v-bind:key="value">
                                                    <span :class="'amenity '+(icons['propertyAmenities'][value] !== undefined ? icons['propertyAmenities'][value] : 'icon-default')" v-if="amenitiesLabels[value] && index < 2">
                                                        {{amenitiesLabels[value].label}}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            </Slick>

                            <span class="slick-arrow slick-prev" :id="'slick-prev-inSalabam'+_uid+'_d'">
                                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.6" d="M30 59.9992C46.5685 59.9992 60 46.5681 60 29.9996C60 13.4311 46.5685 0 30 0C13.4315 0 0 13.4311 0 29.9996C0 46.5681 13.4315 59.9992 30 59.9992Z" fill="white"/>
                                <path d="M33.5758 43.5237L20.2078 30.0001L33.5758 16.4766" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>

                            <span class="slick-arrow slick-next" :id="'slick-next-inSalabam'+_uid+'_d'">
                                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.6" d="M30 59.9992C46.5685 59.9992 60 46.5681 60 29.9996C60 13.4311 46.5685 0 30 0C13.4315 0 0 13.4311 0 29.9996C0 46.5681 13.4315 59.9992 30 59.9992Z" fill="white"/>
                                <path d="M33.5758 43.5237L20.2078 30.0001L33.5758 16.4766" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>

                        </div>

                        <div class="infoPad-wrapper">
                            <div class="infoPad">
                                <div class="background">
                                    <h5 class="title">
                                        <font-awesome-icon icon="eye"/>
                                        Visti di recente
                                    </h5>
                                    <p class="abstract">
                                      Scopri con un click disponibilità e prezzi di tutte le strutture che hai già esaminato
                                    </p>
                                    <span class="btn link" @click="searchLite()">Scopri le disponibilità</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Spinner from '../../atoms/spinner'
import Slick from 'vue-slick'
import SvgOccupancy from '../../svg/occupancy'
import SvgPin from '../../svg/pin'
import User from '@/user'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faEye, faSearch } from '@fortawesome/free-solid-svg-icons'
library.add(faEye)
library.add(faSearch)
Vue.component('font-awesome-icon', FontAwesomeIcon)

export default {
    name: 'history-slider',
    props:{
    },
    components:{
        Spinner,
        Slick,
        SvgOccupancy,
        SvgPin,
    },
    data()
    {
        return {
            icons: Vue.prototype.$config.icons,
            amenitiesLabels: Vue.prototype.$config.amenities,
            loading: true,
            history: this.$store.state.history.properties,
            slickOptionsDesktop: {
                infinite: true,
                //autoplay: (this.$config.guiSettings.autoplaySpeedInSalabam != 0),
                autoplaySpeed: this.$config.guiSettings.autoplaySpeedInSalabam,
                //vertical: true,
                //verticalSwiping: true,
                slidesToShow: 3,
                prevArrow: '#slick-prev-inSalabam'+this._uid+'_d',
                nextArrow: '#slick-next-inSalabam'+this._uid+'_d',
                adaptiveHeight:true,
                responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                    slidesToShow: 2,
                    }
                },
                /*
                {
                    breakpoint: 1200,
                    settings: {
                    slidesToShow: 2,
                    }
                },
                
                {
                    // sotto i 1200 viene nascosto
                }
                */
                ]
            },
            slickOptionsMobile: {
                infinite: true,
                //autoplay: (this.$config.guiSettings.autoplaySpeedInSalabam != 0),
                autoplaySpeed: this.$config.guiSettings.autoplaySpeedInSalabam,
                //vertical: true,
                //verticalSwiping: true,
                slidesToShow: 4,
                prevArrow: '#slick-prev-inSalabam'+this._uid+'_m',
                nextArrow: '#slick-next-inSalabam'+this._uid+'_m',
                adaptiveHeight:true,
                responsive: [
                    /* 
                {
                    breakpoint: 1600,
                    settings: {
                    slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                    slidesToShow: 2,
                    }
                },
                */
                {
                    breakpoint: 993,
                    settings: {
                    //adaptiveHeight:false,
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    //variableWidth: true,
                    //vertical: false,
                    //verticalSwiping: false,
                    }
                }
                ]
            },
        }
    },
    mounted()
    {
        this.loading = false
    },
    methods:{
        handleInit(){
        //handleInit(event, slick) {
            /*
            const [ slickTrack ] = slick.$slideTrack
            slickTrack.childNodes.forEach(slickSlide => {
                let _this = this
                slickSlide.onclick = function(e){
                    let property_id = parseInt(e.target.closest('.property_pad').getAttribute('data-property_id'))
                    let property = _this.history.filter(function (property) {
                        return property.propertyId == property_id
                    })[0]
                    _this.goToProperty(property)
                }
            })
            */
        },
        goToProperty(property)
        {
            User.goToProperty(property, 'history')
        },
        searchLite()
        {
            let properties_ids = []

            this.history.forEach(favorite => {
                properties_ids.push(favorite.property.propertyId)
            })

            let searchParameters = {
                latitude: this.$store.state.geo.latitude,
                longitude: this.$store.state.geo.longitude,
                label: 'La tua cronologia',
                checkin: this.$store.state.dates.checkin,
                checkout: this.$store.state.dates.checkout,
                adults: this.$store.state.occupancy.adults,
                children: this.$store.state.occupancy.children,
                properties_ids: properties_ids
            }

            User.searchLite(searchParameters, 'history')
        },
    },
}
</script>

<style lang="scss">
    .history-slider
    {
        .sliderHeading
        {
            &--icon
            {
                color:$liteGreen;
            }
        }

        .slick .infoPad
        {
            .abstract,
            .title
            {
                color:$white !important;
            }
            .background
            {
                background:$liteGreen !important;
            }
        }
    }
</style>